import React from 'react'
import {useNavigate } from 'react-router-dom'
import { Typography, Image, Table, Tag } from 'antd';
import roadtypeImg from "../lineroad/roadtype.jpg"
import manuImg from "../lineroad/menu2.jpg"
const { Title, Paragraph, Link } = Typography;

export default function Crossroad() {
  const dataSource = [
    {
      key: '1',
      name: '夹角',
      range: '45~135',
      desc: '相交道路中心线夹角。',
    },
    {
      key: '2',
      name: '右转弯半径',
      range: '0~100',
      desc: '交叉口机动车道与人行道路缘石交线的转弯半径。',
    },
    {
      key: '3',
      name: '左转车道拓宽过渡段长',
      range: '0~100',
      desc: '利用中央分隔带作为左转车道拓宽道时的过渡段长度。',
    },
    {
      key: '4',
      name: '右转车道宽度',
      range: '0~20',
      desc: '出道口匝道宽度，交通岛路缘石与人行道路缘石之间的宽度。值为0时无交通岛。',
    },
    {
      key: '5',
      name: '左转车道拓宽宽度',
      range: '0~20',
      desc: '利用中央分隔带作为左转车道拓宽道时的拓宽宽度。',
    },
    {
      key: '6',
      name: '左转车道拓宽长度',
      range: '0~200',
      desc: '利用中央分隔带作为左转车道拓宽道时的拓宽长度。',
    },
    {
      key: '7',
      name: '出口道拓宽',
      range: '0~20',
      desc: '驶出本路口车道的拓宽宽度。',
    },
    {
      key: '8',
      name: '出口道拓宽长',
      range: '0~100',
      desc: '驶出本路口车道拓宽时的拓宽车道长度。',
    },
    {
      key: '9',
      name: '出口道拓宽缓和段长',
      range: '0~100',
      desc: '驶出本路口车道拓宽时的拓宽缓和段长度。',
    },
    {
      key: '10',
      name: '进口道拓宽',
      range: '0~20',
      desc: '驶入本路口车道的拓宽宽度。',
    },
    {
      key: '11',
      name: '进口道拓宽长',
      range: '0~100',
      desc: '驶入本路口车道拓宽时的拓宽车道长度。',
    },
    {
      key: '12',
      name: '进口道拓宽缓和段长',
      range: '0~100',
      desc: '驶入本路口车道拓宽时的拓宽缓和段长度。',
    },
    {
      key: '13',
      name: '渠化岛圆角半径（小）',
      range: '0~5',
      desc: '渠化交通岛靠近进出道口的尖角倒角半径。',
    },
    {
      key: '14',
      name: '渠化岛圆角半径（大）',
      range: '0~10',
      desc: '渠化交通岛靠近交叉口中心的尖角倒角半径。',
    },
    {
      key: '15',
      name: '掉头车道宽',
      range: '0~20',
      desc: '掉头车道在中央分隔带上的开口宽度，最窄处宽。',
    }
  ];

  const columns = [
    {
      title: '参数',
      dataIndex: 'name',
      render: (name)=>{
        return (
          <Tag color={'volcano'} key={name}>
            {name}
          </Tag>
        );
      }
    },
    {
      title: '取值范围',
      dataIndex: 'range',
      key: 'range',
    },
    {
      title: '描述',
      dataIndex: 'desc',
      key: 'desc',
    },
  ];
  const navigate = useNavigate ();
  return (
    <Typography>
      <Title level={2}>介绍</Title>
      <Paragraph>
        本软件提供三种道路效果图场景，分别为直线路段、十字交叉口和特殊路段，交叉口提供了十字交叉口的道路模型。在该场景中，
        通过修改相交路口的道路横断面、交叉口平面参数来修改交叉口的模型。可以通过以下两种方式进入交叉口场景：
      </Paragraph>
      <Paragraph>
        <ul>
          <li>
            通过启动菜单<br></br>
            <Image width={100} src={manuImg} />
          </li>
          <li>
            通过主界面上方区域的道路类型下拉列表框<br></br>
            <Image width={200} src={roadtypeImg} />
          </li>
        </ul>
      </Paragraph>
      <Title level={2}>道路横断面参数</Title>
      <Paragraph>
      <Link onClick={()=>{navigate("/content/roadmodel/lineroad")}}>见直线路段</Link>
      </Paragraph>
      <Title level={2}>交叉口平面参数</Title>
      <Paragraph>
      <Table dataSource={dataSource} columns={columns} pagination={{pageSize:50}}/>;
      </Paragraph>
    </Typography>
  )
}
